import { useEffect, useRef } from "react";
import * as d3 from "d3";

export default function DailyLineChart({ data }) {
  const ref = useRef();

  useEffect(() => {
    const fetchDataAndDrawChart = async () => {
      try {
        drawChart(data);
      } catch (error) {
        console.error("Error fetching daily metrics", error);
      }
    };

    const drawChart = (data) => {

      const margin = { top: 20, right: 30, bottom: 40, left: 50 };
      const width = 800 - margin.left - margin.right;
      const height = 400 - margin.top - margin.bottom;

      d3.select(ref.current).select("svg").remove(); // Clean up

      const svg = d3
        .select(ref.current)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      const x = d3
        .scaleTime()
        .domain(d3.extent(data, d => d.date))
        .range([0, width]);

      const y = d3
        .scaleLinear()
        .domain([
          d3.min(data, d => d.actualGain),
          d3.max(data, d => d.actualGain)
        ])
        .nice()
        .range([height, 0]);

      const line = d3
        .line()
        .x(d => x(d.date))
        .y(d => y(d.actualGain));

      svg.append("g")
        .attr("transform", `translate(0,${height})`)
        .call(d3.axisBottom(x).ticks(6));

      svg.append("g").call(d3.axisLeft(y));

      svg.append("line")
        .attr("x1", 0)
        .attr("x2", width)
        .attr("y1", y(0))
        .attr("y2", y(0))
        .attr("stroke", "#ccc")
        .attr("stroke-width", 1)
        .attr("stroke-dasharray", "4 2");

      svg.append("path")
        .datum(data)
        .attr("fill", "none")
        .attr("stroke", "#3f51b5")
        .attr("stroke-width", 2)
        .attr("d", line);

      // Tooltip
      const focus = svg.append("g")
        .style("display", "none");

      focus.append("circle")
        .attr("r", 5)
        .attr("fill", "#3f51b5");

      focus.append("text")
        .attr("x", 10)
        .attr("y", -10)
        .attr("class", "tooltip-text")
        .style("font-size", "12px");

      svg.append("rect")
        .attr("width", width)
        .attr("height", height)
        .style("fill", "none")
        .style("pointer-events", "all")
        .on("mouseover", () => focus.style("display", null))
        .on("mouseout", () => focus.style("display", "none"))
        .on("mousemove", function (event) {
          const bisect = d3.bisector(d => d.date).left;
          const x0 = x.invert(d3.pointer(event, this)[0]);
          const i = bisect(data, x0, 1);
          const d0 = data[i - 1];
          const d1 = data[i];
          const dClosest = x0 - d0.date > d1.date - x0 ? d1 : d0;
          focus.attr("transform", `translate(${x(dClosest.date)},${y(dClosest.actualGain)})`);
          focus.select("text").text(`$${dClosest.actualGain.toFixed(2)}`);
        });
    };

    fetchDataAndDrawChart();
  }, [data]);

  return <div ref={ref} style={{ marginTop: 40 }} />;
}
